import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "./Pages/Login";
import Sign from "./Pages/sign";
import Verify from "./Pages/verify";
import Callback from "./Pages/Callback";
import ForgetPassword from "./Pages/ForgetPassword";
import SetPassword from "./Pages/SetPassword";
import SendInformation from "./Pages/SendInformation";
import ManageHome from "./Pages/ManageHome";
import OtpVerify from "./Pages/OtpVerify";
import AccountInfo from "./Pages/Dashboard/AccountInfo";
import Hdash from "./Pages/Dashboard/Hdash";
import ProtectedRoute from "./Pages/ProtectedRoute";
import Deposit from "./Pages/Dashboard/Deposit";
import AddCard from "./Pages/Dashboard/AddCard";
import Kifpool from "./Pages/Dashboard/kifpool";
import TradeMarket from "./Pages/Dashboard/TradeMarket";
import GoldBalance from "./Pages/Dashboard/GoldBalance";
import LimitOrder from "./Pages/Dashboard/LimitOrder";
import Requests from "./Pages/Dashboard/Requests";
import EditInfo from "./Pages/Dashboard/EditInfo";
import AboutUs from "./Pages/AboutUs";
import Helper from "./Pages/Helper";
import Faq from "./Pages/Faq";
import Ruls from "./Pages/Ruls";
import ReferralInvitation from "./Pages/ReferralInvitation";
import PhysicalGold from "./Pages/Dashboard/PhysicalGold";
import NotFount from "./Pages/NotFound";
import Blog from "./Pages/Blog";
import BlogDetail from "./Pages/BlogDetails";
import ShopRules from "./Pages/Rules";
import Home from "./Home";

const MainPages = () => {
  return (
    <Routes>
      <Route path="/" element={<ManageHome />} />
      <Route path="/home" element={<Hdash />} />
      <Route element={<ProtectedRoute user={true} />}>
        <Route path="dashboard" element={<Hdash />} />
      </Route>
      <Route path={"/login"} element={<Login />} />
      <Route path={"/sign"} element={<Sign />} />
      <Route path={"/callback"} element={<Callback />} />
      <Route path={"/otp_verify"} element={<OtpVerify />} />
      <Route path={"/invitation"} element={<ReferralInvitation />} />
      <Route path={"/verify"} element={<Verify />} />
      <Route path={"/forgetpassword"} element={<ForgetPassword />} />
      <Route path={"/setpassword"} element={<SetPassword />} />
      <Route path={"/sendinfo"} element={<SendInformation />} />
      <Route path={"/account-info"} element={<AccountInfo />} />
      <Route path={"/addcard"} element={<AddCard />} />
      <Route path={"/kifpool"} element={<Kifpool />} />
      <Route path={"/deposit"} element={<Deposit />} />
      <Route path={"/trade-market"} element={<TradeMarket />} />
      <Route path={"/limit-order"} element={<LimitOrder />} />
      <Route path={"/gold-balance"} element={<GoldBalance />} />
      <Route path={"/physical-gold"} element={<PhysicalGold />} />
      <Route path={"/requests"} element={<Requests />} />
      <Route path={"/edit-information"} element={<EditInfo />} />
      <Route path={"/info"} element={<AccountInfo typeAc={"info"} />} />
      <Route
        path={"/checking-auth"}
        element={<AccountInfo typeAc={"auth"} />}
      />
      <Route path={"/about"} element={<AboutUs />} />
      <Route path={"/help"} element={<Helper />} />
      <Route path={"/blog"} element={<Blog />} />
      <Route path={"/blog/:title"} element={<BlogDetail />} />
      <Route path={"/faq"} element={<Faq />} />
      <Route path={"/privacy"} element={<Ruls />} />
      <Route path="/rules" element={<ShopRules />} />
      <Route path={"/*"} element={<NotFount />} />
    </Routes>
  );
};

export default MainPages;
